import { useQuery } from "@tanstack/react-query";
import api from "../services/newApi/api";
import { queryKeys } from "../lib/queryKeys";

export const useAuthFeatureFlag = (key: string) => {
  const { data, isLoading } = useQuery({
    queryKey: queryKeys.featureFlags.auth(key),
    queryFn: async () => {
      const response = await api.get<{
        status: string;
        data: { key: string; enabled: boolean };
      }>(`/feature-flags/${key}`);
      // react-query proíbe undefined como data; flag ausente/sem payload → null.
      return response.data?.data ?? null;
    },
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  return {
    enabled: isLoading ? false : (data?.enabled ?? false),
    loading: isLoading,
  };
};
